export function changePhoneNumber(props) {
  var re = /(?:([\d]{1,}?))??(?:([\d]{1,3}?))??(?:([\d]{1,3}?))??(?:([\d]{2}))??([\d]{2})$/;
  return props.replace(re, function (all, a, b, c, d, e) {
    return (// eslint-disable-next-line
      (a ? a + ' ' : '') + (b ? b + ' ' : '') + (c ? c + '-' : '') + (d ? d + '-' : '') + e
    );
  });
}